export default {
  sections: {
    business_info: 'Yrityksen tiedot',
    bank_info: 'Pankkitiedot',
  },
  form: {
    company_name: {
      label: 'Ravintolan nimi',
      placeholder: 'Ravintolan nimi',
    },
    business_name: {
      label: 'Yrityksen nimi',
      placeholder: 'Yrityksen nimi',
    },
    owner_full_name: {
      label: 'Omistajan nimi',
      placeholder: 'Omistajan nimi',
    },
    business_address: {
      label: 'Yrityksen osoite',
      placeholder: 'Yrityksen osoite',
    },
    business_zip_code: {
      label: 'Yrityksen postinumero',
      placeholder: 'Yrityksen postinumero',
    },
    business_city: {
      label: 'Yrityksen kaupunki',
      placeholder: 'Yrityksen kaupunki',
    },
    business_country: {
      label: 'Yrityksen maa',
      options: {
        DE: 'Saksa',
        GB: 'Yhdistynyt kuningaskunta',
        US: 'Yhdysvallat',
      },
    },
    company_phone_number: {
      label: 'Ravintolan puhelinnumero',
      placeholder: 'Ravintolan puhelinnumero',
    },
    contact_person_full_name: {
      label: 'Yhteyshenkilön nimi',
      placeholder: 'Yhteyshenkilön nimi',
    },
    contact_person_phone_number: {
      label: 'Yhteyshenkilön puhelinnumero',
      placeholder: 'Yhteyshenkilön puhelinnumero',
    },
    contact_person_email: {
      label: 'Yhteyshenkilön sähköposti',
      placeholder: 'Yhteyshenkilön sähköposti',
    },
    business_bank_account_holder_name: {
      label: 'Pankkitilin haltijan nimi',
      placeholder: 'Pankkitilin haltijan nimi',
    },
    business_bank_account_number: {
      label: 'Pankkitilinumero',
      placeholder: 'DE01101234567891234567',
    },
    business_bank_routing_number: {
      label: 'Pankin reititysnumero',
      placeholder: '110000000',
    },
    business_tax_id: {
      label: 'Yrityksen verotunnus',
      placeholder: 'Yrityksen verotunnus',
    },
  },
};
